/**
 * My API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface SiemensEnergyCOINClientApiHandlersMeritCalculationsMeritSingleCalculationCommand {
  seasonId?: string;
  simulationId?: string;
  gids?: Array<string> | null;
  ignoreValidations?: boolean | null;
  includeManagerAssignment?: boolean;
  settingId?: string | null;
  type?: SiemensEnergyCOINClientApiHandlersMeritCalculationsMeritSingleCalculationCommandTypeEnum;
}
export enum SiemensEnergyCOINClientApiHandlersMeritCalculationsMeritSingleCalculationCommandTypeEnum {
  NUMBER_0 = 0,
  NUMBER_1 = 1,
  NUMBER_2 = 2,
  NUMBER_3 = 3
}
